"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../Utilities");
var DependencyLoader = (function () {
    function DependencyLoader() {
        this.context = {};
        this.dependencies = {};
        this.loadedControls = {};
        this.loadedStyles = {};
    }
    DependencyLoader.prototype.setContext = function (context) {
        this.context = context;
    };
    DependencyLoader.prototype.buildAssetUrl = function (packageName, assetName, assetType) {
        var url = [];
        var basePath = this.context.basePath;
        url.push(basePath);
        if (basePath[basePath.length - 1] !== '/') {
            url.push('/');
        }
        if (packageName !== this.context.package) {
            url.push('node_modules/', 'player-', packageName, '/');
        }
        if (assetType === 'assetStyle') {
            url.push('assets/', assetName, '.css');
        }
        else if (assetType === 'assetScript') {
            url.push('assets/', assetName, '.js');
        }
        else if (assetType === 'controlScript') {
            url.push('controls/', assetName, '.js');
        }
        else if (assetType === 'controlStyle') {
            url.push('controls/', assetName, '.css');
        }
        else if (assetType === 'pageControls') {
            url.push('pages/', assetName, '.controls.js');
        }
        else if (assetType === 'pageStyles') {
            url.push('pages/', assetName, '.styles.css');
        }
        else {
            url.push('undefined');
            console.warn('A correct asset type is not defined. Can not build a URL from it.');
        }
        return url.join('');
    };
    DependencyLoader.prototype.injectAsset = function (packageName, assetName, assetType) {
        if (assetName === 'csod-icons' || assetName === 'normalize') {
            var normalize = document.getElementById('player-normalize');
            var icons = document.getElementById('player-icons');
            if (normalize)
                return Promise.resolve();
            if (icons)
                return Promise.resolve();
        }
        switch (assetType) {
            case 'style':
                return this.loadStyle(packageName, assetName, 'assetStyle', false);
            case 'topStyle':
                return this.loadStyle(packageName, assetName, 'assetStyle', true);
            case 'controlStyle':
                return this.loadStyle(packageName, assetName, 'controlStyle', false);
            case 'script':
                return this.loadScript(packageName, assetName, 'assetScript');
            default:
                console.warn('Asset type not defined.');
                return;
        }
    };
    DependencyLoader.prototype.injectPageControlsForPreview = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = _this.buildAssetUrl(_this.context.package, _this.context.page, 'pageControls');
            Promise.all([
                Utilities_1.appendScript(url).then(function () {
                    var promises = [];
                    for (var key in Utilities_1.loadedScripts) {
                        if (key !== url)
                            promises.push(Utilities_1.loadedScripts[key]);
                    }
                    return Promise.all(promises);
                }),
                _this.handlePageStyles(),
                _this.injectAsset('core-ui', 'csod-icons', 'topStyle'),
                _this.injectAsset('core-ui', 'normalize', 'topStyle')
            ]).then(function () {
                resolve({});
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    DependencyLoader.prototype.injectPageControls = function () {
        if (this.context.previewMode) {
            return this.injectPageControlsForPreview();
        }
        var promises = [];
        for (var key in Utilities_1.loadedScripts) {
            promises.push(Utilities_1.loadedScripts[key]);
        }
        return Promise.all(promises);
    };
    DependencyLoader.prototype.handlePageStyles = function () {
        var pageStylesNode = document.getElementById('player-page-styles');
        if (!pageStylesNode) {
            var node = document.getElementById('player-theming');
            if (node) {
                this.loadPageStyles(this.context.package, this.context.page, 'pageStyles', node);
            }
            else {
                this.loadStyle(this.context.package, this.context.page, 'pageStyles', false);
            }
        }
        return Promise.resolve();
    };
    DependencyLoader.prototype.loadScript = function (packageName, assetName, assetType) {
        var url = this.buildAssetUrl(packageName, assetName, assetType);
        return Utilities_1.appendScript(url);
    };
    DependencyLoader.prototype.loadScriptByUrl = function (url) {
        return Utilities_1.appendScript(url);
    };
    DependencyLoader.prototype.loadStyle = function (packageName, assetName, assetType, toTop) {
        var styleKey = packageName + '_' + assetName;
        if (styleKey in this.loadedStyles) {
            this.loadedStyles[styleKey] += 1;
            Utilities_1.head.appendChild(document.getElementById(styleKey + '_css'));
            return Promise.resolve(styleKey);
        }
        else {
            this.loadedStyles[styleKey] = 1;
            return Utilities_1.appendCSS(styleKey, this.buildAssetUrl(packageName, assetName, assetType), toTop);
        }
    };
    DependencyLoader.prototype.loadPageStyles = function (packageName, assetName, assetType, node) {
        var styleKey = packageName + "_" + assetName;
        return Utilities_1.prependCSS(styleKey, this.buildAssetUrl(packageName, assetName, assetType), node);
    };
    return DependencyLoader;
}());
exports.DependencyLoader = DependencyLoader;



//////////////////
// WEBPACK FOOTER
// ./src/DependencyLoader/index.ts
// module id = 49
// module chunks = 0